export default class TeachingDevListCtrl {

  constructor ($scope, $timeout, WorkPlanSrv, $mdDialog, $cookies, GlobalConfig, WorkPlanModalSrv, $filter, Requests, $sessionStorage) {
    var teachingDevListVm = this
    const currentUser = JSON.parse($cookies.get('currentUser'))
    let post = {
      workplanId: currentUser.workplanId,
      teacherId: currentUser.teacherId
    }

    teachingDevListVm.mainLabel = 'Desarrollo profesoral'
    teachingDevListVm.courseList = []
    teachingDevListVm.viewLoaded = false
    teachingDevListVm.gradRoleClass = 'grad-1'
    teachingDevListVm.active = GlobalConfig.generals.active
    teachingDevListVm.notActive = GlobalConfig.generals.notActive
    teachingDevListVm.inReview = 0
    teachingDevListVm.feedback = 0
    teachingDevListVm.planningFinish = true
    teachingDevListVm.workPlanGeneralList = $sessionStorage.workPlanGeneralList
    teachingDevListVm.$sessionStorage = $sessionStorage
    teachingDevListVm.carouselResponsiveBreakpoints = [
      {
        breakpoint: 1360,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }, {
        breakpoint: 1366,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      }, {
        breakpoint: 1920,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      }, {
        breakpoint: 3000,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3
        }
      }
    ]

    teachingDevListVm.imgEmpty = require('../../../../../../assets/images/empty_state_illustration.svg')

    teachingDevListVm.confirmDeleteCourse = confirmDeleteCourse
    teachingDevListVm.updateView = updateView
    teachingDevListVm.getGeneralsWorkplan = getGeneralsWorkplan
    teachingDevListVm.loadData = loadData
    teachingDevListVm.validateSearch = validateSearch
    teachingDevListVm.bitacora = bitacora


    function validateSearch () {
      return $filter('filter')(teachingDevListVm.courseList, teachingDevListVm.courseListSearch)
    }

    activate()

    function activate () {
      if(teachingDevListVm.workPlanGeneralList != undefined){
        teachingDevListVm.status = teachingDevListVm.workPlanGeneralList.wokplanTeacherStatus[0]
        teachingDevListVm.stages = teachingDevListVm.workPlanGeneralList.stages
        teachingDevListVm.inReview = teachingDevListVm.status.reviewed
        teachingDevListVm.feedback = teachingDevListVm.status.feedbackReviewed
        teachingDevListVm.workplanTeacherId = teachingDevListVm.status.workplanTeacherId
        isPlanning(teachingDevListVm.status, teachingDevListVm.stages)
        
        if (teachingDevListVm.feedback && !teachingDevListVm.planningFinish) {
          getDataCoursesListReject()
        } else {
          getDataCoursesList()
        }
      }else{
        getGeneralsWorkplan(post).then((promise) => {
          if (teachingDevListVm.feedback && !teachingDevListVm.planningFinish) {
            getDataCoursesListReject()
          } else {
            getDataCoursesList()
          }
        })
      }

      updateView()
    }

    function getDataCoursesList () {
      WorkPlanSrv.getDataCoursesList.getList(post).$promise.then(dataReturn => {
        dataReturn.status ? loadData(dataReturn.listCourses) : console.log('Comunications problem')
      })
    }

    function getDataCoursesListReject () {
      WorkPlanSrv.getDataCoursesListReject.getList(post).$promise.then(dataReturn => {
        dataReturn.status ? loadData(dataReturn.listCourses) : console.log('Comunications problem')
      })
    }

    function updateView () {
      teachingDevListVm.viewLoaded = false
      $timeout(() => {
        teachingDevListVm.viewLoaded = true
      }, 1)
    }

    function loadData (data) {
      teachingDevListVm.courseList = data
      for (var i = teachingDevListVm.courseList.length - 1; i >= 0; i--) {
        if (teachingDevListVm.courseList[i].typeCourseId == GlobalConfig.courseType.courseExternal) {
          teachingDevListVm.courseList[i].isEditable = true
        } else {
          teachingDevListVm.courseList[i].isEditable = false
        }

        if(teachingDevListVm.courseList[i].timeRangeTypeId == 1){
          teachingDevListVm.courseList[i].periodicityName = teachingDevListVm.courseList[i].periodicityName.replaceAll(',','.').replaceAll('.',', ')
        }

      }
      console.log('listado de desarrollo', teachingDevListVm.courseList)
    }

    String.prototype.replaceAll = function(searchStr, replaceStr) {
      var str = this;
      if(str.indexOf(searchStr) === -1) 
        return str
      return (str.replace(searchStr, replaceStr)).replaceAll(searchStr, replaceStr);
    }

    function confirmDeleteCourse (itemCourse) {
      let courseName = itemCourse.nameCourse
      let workplanTeacherActivityId = itemCourse.workplanTeacherActivityId
      $mdDialog.show({
        controller: ['$scope', '$mdDialog', 'WorkPlanIndicatorSrv', function ($scope, $mdDialog, WorkPlanIndicatorSrv) {
          let ctrlModalVM = this
          ctrlModalVM.courseName = courseName
          ctrlModalVM.workplanTeacherActivityId = workplanTeacherActivityId
          ctrlModalVM.close = function () {
            $mdDialog.hide()
          }
          ctrlModalVM.deleteCourse = function () {
            WorkPlanSrv.disableActivityTeachingStaff.delete({workplanTeacherActivityId: ctrlModalVM.workplanTeacherActivityId})
          .$promise.then(function (dataReturn) {
            if (dataReturn.status) {
              removeCourseFromCaroussel(itemCourse)
              showDeletedSuccessfully(ctrlModalVM.courseName)
              WorkPlanIndicatorSrv.setVariable(true)
              $mdDialog.hide()
            } else {
              console.log('Comunications problem with the server')
            }
          }, function (data) {

          })
          }
        }],
        controllerAs: 'ctrlModalVM',
        template: require('./deleteCourseModal.html'),
        clickOutsideToClose: false
      })
    }

    function showDeletedSuccessfully (courseName) {
      let texts = GlobalConfig.appTexts
      let header = {
        createOrEdit: texts.deleteDialog,
        textCreateOrEdit: texts.deleted,
        itemName: courseName,
        nameModal: texts.modalTypeName.deleted,
        modalType: texts.modalTypeId.default
      }
      WorkPlanModalSrv.setVariableSuccessDialog(header)
      WorkPlanModalSrv.successDialog(header).then((promise) => { })
    }

    function removeCourseFromCaroussel (itemCourse) {
      for (var i in teachingDevListVm.courseList) {
        if (teachingDevListVm.courseList[i].workplanTeacherActivityId === itemCourse.workplanTeacherActivityId) {
          teachingDevListVm.courseList.splice(i, 1)
          updateView()
          break
        }
      }
    }

    function getGeneralsWorkplan (post) {
      return WorkPlanSrv.getElementsRightBar.getList({teacherId: post.teacherId}).$promise.then(function (dataReturn) {
        if (dataReturn.status) {
          teachingDevListVm.$sessionStorage.workPlanGeneralList = dataReturn.data
          teachingDevListVm.status = dataReturn.data.wokplanTeacherStatus[0]
          teachingDevListVm.stages = dataReturn.data.stages
          teachingDevListVm.inReview = teachingDevListVm.status.reviewed
          teachingDevListVm.feedback = teachingDevListVm.status.feedbackReviewed
          teachingDevListVm.workplanTeacherId = teachingDevListVm.status.workplanTeacherId
          isPlanning(teachingDevListVm.status, teachingDevListVm.stages)
        } else {
          console.log('Comunications problem with the server')
        }
      }, function (data) {
        console.log(data)
      })
    }

    function isPlanning (status, stages) {
      teachingDevListVm.currentDate = moment(new Date()).format('DD/MM/YYYY')
      for (var i = stages.length - 1; i >= 0; i--) {
        if (stages[i].stageId == GlobalConfig.workplanIdStages.review) {
          teachingDevListVm.startDateStage = stages[i].startDate
        }
      }

      if(status.workplanActive){
        if (status.planningFinish == teachingDevListVm.active) {
          teachingDevListVm.planningFinish = true
          if (teachingDevListVm.startDateReview < teachingDevListVm.currentDate || status.reviewedFinish == teachingDevListVm.active) {
            teachingDevListVm.planningFinish = true
          } else if (status.reviewedReject == teachingDevListVm.active) {
            teachingDevListVm.planningFinish = false
          }
        } else {
          teachingDevListVm.planningFinish = false
        }
      }else{
        teachingDevListVm.planningFinish = true
      }

      $scope.classPlanning = (teachingDevListVm.planningFinish ? 'disabled' : ' ')
    }

    function bitacora (ev) {
      let entries = {}

      entries.params = {
        activityTypeId: GlobalConfig.activityTypeId.teacherDevelopment,
        workplanTeacherId: teachingDevListVm.workplanTeacherId
      }
      entries.title = 'Desarrollo profesoral'
      // Entries(this.entries);
      entries.data = undefined
      $mdDialog.show({
        controller: 'bitacoraModalCtrl',
        controllerAs: 'bit',
        template: require('../../../../strategicTracking/detailsByTeacher/bitacoraModal/bitacoraModal.html'),
        parent: angular.element(document.body),
        targetEvent: ev,
        locals: {data: entries},
        clickOutsideToClose: true,
        fullscreen: true
      })
    }
    
  }
}

TeachingDevListCtrl.$inject = ['$scope', '$timeout', 'WorkPlanSrv', '$mdDialog', '$cookies', 'GlobalConfig', 'WorkPlanModalSrv', '$filter', 'Requests', '$sessionStorage']



// WEBPACK FOOTER //
// ./src/app/u-faculty/workplan/consolidationCP/teachingDevelopment/list/teachingDevListCtrl.js